var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletMale = function SvgIcToiletMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M21.249 12.862a2.08 2.08 0 0 0-1.73-.912h-6.534c-.704 0-1.336.334-1.73.912a2.06 2.06 0 0 0-.226 1.944l3.22 8.377a.4.4 0 0 1 .024.137v4.293c0 1.091.888 1.98 1.98 1.98 1.09 0 1.979-.889 1.979-1.98V23.32q-.002-.072.024-.137l3.22-8.377a2.09 2.09 0 0 0-.227-1.944ZM16.248 10.076a3.146 3.146 0 1 0 0-6.293 3.146 3.146 0 0 0 0 6.293Z"
  })));
};
export default SvgIcToiletMale;